import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { FitnessCommerceService } from '../../services/fitness-commerce.service';
import { OrderHistoryDetail, OrderHistorySummary } from '../../models/order-history.models';

@Component({selector: 'app-fitness-orders', templateUrl: './fitness-orders.component.html',
    styleUrls: ['./fitness-orders.component.scss']})
export class FitnessOrdersComponent implements OnInit, OnDestroy {
    orders: OrderHistorySummary[] = [];
    order: OrderHistoryDetail;
    orderId: number;
    detail = false;
    showAll = false;
    loading = false;
    error = '';
    private sub = new Subscription();
    private request: Subscription;
    constructor(private commerce: FitnessCommerceService, private route: ActivatedRoute) {}
    ngOnInit(): void {
        this.sub.add(this.commerce.accountChanged$.subscribe(() => {
            this.request?.unsubscribe(); this.orders = []; this.order = null; this.loading = false;
            this.error = 'Your account changed. Reload to see your orders.';
        }));
        this.sub.add(this.route.paramMap.subscribe(params => {
            this.detail = params.has('orderId'); this.orderId = +params.get('orderId'); this.load();
        }));
    }
    load(): void {
        this.request?.unsubscribe(); this.orders = []; this.order = null; this.error = '';
        if (this.detail && (!Number.isSafeInteger(this.orderId) || this.orderId <= 0)) {
            this.loading = false; this.error = 'Order was not found. Return to My orders to choose an order.'; return;
        }
        this.loading = true;
        const failed = (error: { status?: number }) => {
            this.loading = false;
            this.error = error.status === 404 ? 'Order was not found. Return to My orders to choose an order.' :
                'We couldn’t load your orders. Please try again.';
        };
        this.request = this.detail ? this.commerce.orderDetails(this.orderId).subscribe(order => {
            this.order = order; this.loading = false;
        }, failed) : this.commerce.orders(this.showAll).subscribe(orders => {
            this.orders = orders; this.loading = false;
        }, failed);
    }
    allOrders(): void { this.showAll = true; this.load(); }
    ngOnDestroy(): void { this.request?.unsubscribe(); this.sub.unsubscribe(); }
}
